import React from "react";
import { SpinnerLoader } from "@activecollab/components";

export const LoaderWrapper = () => {
  return (
    <div className="tw-h-screen tw-flex tw-items-center tw-justify-center">
      <SpinnerLoader />
    </div>
  );
};
